import * as React from 'react';
import { City } from 'contracts/cities';
import { apiGeneral, queryBuilder } from 'services/api';

type FindByProps = {
  field: 'id' | 'ibge',
  value: number | string;
}

export const useFetchCityByFieldAndValue = () => {
  const fetchCityByFieldAndValue = React.useCallback(async (props: FindByProps): Promise<City | null> => {
    const queryString = queryBuilder(props);
    const { data } = await apiGeneral.get<City | null>(`/cities/find-by?${queryString}`);
    return data;
  }, []);

  return {
    fetchCityByFieldAndValue,
  };
};